<template>
  <div class="language-switcher relative" ref="dropdownRef">
    <button
      @click="toggleDropdown"
      class="language-switcher__button flex items-center space-x-2 px-3 py-2 rounded-lg text-gray-700 hover:text-purple-700 hover:bg-gray-100 transition duration-300"
      :aria-label="$t('common.language_switch')"
    >
      <i class="fas fa-globe text-lg"></i>
      <span class="language-switcher__label text-sm font-medium">{{ currentLanguageLabel }}</span>
      <i class="fas fa-chevron-down text-xs transition-transform duration-200" :class="{ 'rotate-180': isOpen }"></i>
    </button>
    
    <transition name="dropdown">
      <div
        v-show="isOpen"
        class="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-lg shadow-xl z-50"
      >
        <button
          v-for="lang in supportedLanguages"
          :key="lang.code"
          @click="handleLanguageChange(lang.code)"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition duration-200 first:rounded-t-lg last:rounded-b-lg flex items-center justify-between"
          :class="{ 'bg-purple-50 text-purple-700 font-semibold': locale === lang.code }"
        >
          <span>{{ lang.nativeLabel }}</span>
          <i v-if="locale === lang.code" class="fas fa-check text-purple-700"></i>
        </button>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18nHelpers } from '@/composables/useI18nHelpers'

const { locale, currentLanguageLabel, supportedLanguages, switchLanguage } = useI18nHelpers()
const isOpen = ref(false)
const dropdownRef = ref(null)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const handleLanguageChange = (langCode) => {
  switchLanguage(langCode)
  isOpen.value = false
}

// 点击外部关闭下拉菜单
const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.language-switcher {
  flex: 0 0 auto;
}

.language-switcher__button {
  min-width: 0;
  white-space: nowrap;
}

.rotate-180 {
  transform: rotate(180deg);
}

/* 下拉菜单动画 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 1279.98px) {
  .language-switcher__button {
    padding-left: 0.65rem;
    padding-right: 0.65rem;
  }

  .language-switcher__label {
    display: none;
  }
}
</style> 
